import React from 'react';
import PropTypes from 'prop-types';
import PatientRescheduledInformationDialogContainer from '../../../containers/Patients/Patient/PatientRescheduledInformationDialogContainer';

class PatientRescheduledInformationDialogOpener extends React.Component {
  onClick = () => {
    const { onOpen, show, id, getRescheduledInformation, treatmentInstanceId } = this.props;
    getRescheduledInformation(treatmentInstanceId);
    onOpen(id);
    show(id);
  };

  render() {
    return (
      <span>
        <i role="button" tabIndex="-1" className="allocateIcons info" onClick={this.onClick}>
          schedule
        </i>
        <PatientRescheduledInformationDialogContainer
          id={this.props.id}
          treatmentInstanceId={this.props.treatmentInstanceId}
        />
      </span>
    );
  }
}

PatientRescheduledInformationDialogOpener.defaultProps = {
  onOpen: () => {},
};

PatientRescheduledInformationDialogOpener.propTypes = {
  id: PropTypes.string.isRequired,
  show: PropTypes.func.isRequired,
  treatmentInstanceId: PropTypes.number.isRequired,
  getRescheduledInformation: PropTypes.func.isRequired,
  onOpen: PropTypes.func,
};

export default PatientRescheduledInformationDialogOpener;
